import { IQuickTimeSlot, IRange, isSameMinute } from '@jooxter/utils';

export const isSlotSelected = (s: IQuickTimeSlot, range: IRange): boolean => {
  return isSameMinute(s.start, range.from) && isSameMinute(s.end, range.to);
};
